import { defineMessages } from 'react-intl';

export const useOpenFreightGetHelpFormMessages = defineMessages({
  submitErrorTitle: {
    defaultMessage: 'Unable to submit request',
    id: 'oZ66u0',
    description: 'Notification title shown when the freight Get Help form fails to open',
  },
});
